import api from 'base/utils/api';
import { IInitInfo, IQuickRegisterParams } from 'base/interfacesV2/user';

/**
 * 获取客户端初始信息
 * TODO API: 0|1 转布尔值; currentTime 使用数字格式
 */
export function getInitInfo(): Promise<IInitInfo> {
    return api.get('/web/init/info').then(res => {
        return {
            ...res,
            isLogin: !!res.isLogin,
            isGuestUser: !!res.isGuestUser,
            currentTime: Number(res.currentTime),
        }
    })
}

/**
 * 快速注册
 * @param params 快速注册参数
 */
export async function quickRegister(params: IQuickRegisterParams) {
    return api.post('/web/user/quick_register', {
        data: params
    })
}

/**
 * 创建匿名用户
 * @param params 邮箱
 */
export async function createGuestAccount(params: IQuickRegisterParams) {
    return api.post('/web/user/createGuestAccount', {
        data: params
    })
}
